import PropTypes from 'prop-types';
import { toast } from '../../utilities/appToast';
import { isEmail } from '../../utilities/formatString';
import { requestTokenResetPasswordAdmin } from '../../api/axios';

export const Token = ({ colSize, token, usuario, showSpinner, isResetMode, changeShowSpinner, setToken, fetchTokenUsuario, parseResetTokenResponse }) => {
    const generateResetPasswordToken = async () => {
        if (isResetMode) return;

        const email = (usuario?.email || "").trim();

        changeShowSpinner(true);
        try {
            if (!email) {
                toast.warn("El usuario no tiene email cargado.");
                return;
            }
            if (!isEmail(email)) {
                toast.warn("Mail incorrecto.");
                return;
            }

            // This endpoint typically sends the email. It may or may not return the token in the response.
            const raw = await requestTokenResetPasswordAdmin(email);
            const tokenFromResponse = parseResetTokenResponse(raw);
            if (tokenFromResponse) {
                setToken(tokenFromResponse);
            }

            toast.success("Token solicitado. Se envió el correo al usuario.");

            // After requesting by email, try to fetch the token by idUsuario for display (if Core supports it once requested).
            await fetchTokenUsuario(true);
        } catch {
            // In some environments the email is sent but the API responds non-2xx.
            toast.success("Token solicitado. Se envió el correo al usuario.");
            await fetchTokenUsuario(true);
        } finally {
            changeShowSpinner(false);
        }
    };

    const copyResetTokenToClipboard = async () => {
        const tokenParse = (token || "").trim();
        if (!tokenParse) return;

        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(tokenParse);
                toast.success("Token copiado al portapapeles.");
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = tokenParse;
                textArea.setAttribute("readonly", "");
                textArea.style.position = "absolute";
                textArea.style.left = "-9999px";
                document.body.appendChild(textArea);
                textArea.select();
                const ok = document.execCommand("copy");
                textArea.remove();
                ok ? toast.success("Token copiado al portapapeles.") : toast.error("No se pudo copiar el token.");
            }
        } catch {
            toast.error("No se pudo copiar el token.");
        }
    };

    return (
        <div className={colSize}>
            <div className="form-group">
                <div className="d-flex gap-2">
                    <button
                        type="button"
                        className={`btn btn-sm flex-shrink-0 ${(token || "").trim().length > 0 ? "btn-outline-danger" : "background-rojo-megatone text-white border-0"}`}
                        onClick={() => {
                            const ok = window.confirm(
                                "Obtener token de reinicio de contraseña.\n\n" +
                                "Si el usuario ya tiene un token activo, se mostrará.\n" +
                                "Si no existía, esta acción puede generar uno nuevo.\n\n" +
                                "¿Continuar?"
                            );
                            if (!ok) return;
                            generateResetPasswordToken();
                        }}
                        disabled={showSpinner || !usuario?.email}
                        title="Obtiene el token (puede generar uno nuevo si no existía)"
                    >
                        Obtener token
                    </button>

                    {(token || "").trim().length > 0 &&
                        <div className="w-100">
                            <label htmlFor="tokenUserEdit" className="mb-1">Token</label>
                            <div className="d-flex gap-2 align-items-center">
                                <input
                                    id="tokenUserEdit"
                                    type="text"
                                    className="form-control"
                                    value={token || ""}
                                    readOnly
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary flex-shrink-0"
                                    onClick={copyResetTokenToClipboard}
                                    title="Copiar token al portapapeles"
                                >
                                    Copiar
                                </button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
Token.propTypes = {
    colSize: PropTypes.string,
    token: PropTypes.string,
    usuario: PropTypes.shape({
        email: PropTypes.string,
    }),
    showSpinner: PropTypes.bool,
    isResetMode: PropTypes.bool,
    changeShowSpinner: PropTypes.func,
    setToken: PropTypes.func,
    fetchTokenUsuario: PropTypes.func,
    parseResetTokenResponse: PropTypes.func,
}